"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeInfoResponseAllOfToJSON = exports.ChallengeInfoResponseAllOfFromJSONTyped = exports.ChallengeInfoResponseAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChallengeInfoResponseAllOfFromJSON(json) {
    return ChallengeInfoResponseAllOfFromJSONTyped(json, false);
}
exports.ChallengeInfoResponseAllOfFromJSON = ChallengeInfoResponseAllOfFromJSON;
function ChallengeInfoResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isAccepted': !(0, runtime_1.exists)(json, 'isAccepted') ? undefined : json['isAccepted'],
        'prizes': (json['prizes'].map(_1.PrizePoolFromJSON)),
        'winners': !(0, runtime_1.exists)(json, 'winners') ? undefined : (json['winners'].map(_1.ChallengeMembershipFromJSON)),
        'brandMapSlug': !(0, runtime_1.exists)(json, 'brandMapSlug') ? undefined : json['brandMapSlug'],
        'instantReward': !(0, runtime_1.exists)(json, 'instantReward') ? undefined : (0, _1.ChallengeInstantRewardFromJSON)(json['instantReward']),
        'dismissedCompleteFeedBack': !(0, runtime_1.exists)(json, 'dismissedCompleteFeedBack') ? undefined : json['dismissedCompleteFeedBack'],
        'games': !(0, runtime_1.exists)(json, 'games') ? undefined : (json['games'].map(_1.OWGameResponseFromJSON)),
        'quests': !(0, runtime_1.exists)(json, 'quests') ? undefined : (json['quests'].map(_1.QuestConfigFromJSON)),
        'progressions': !(0, runtime_1.exists)(json, 'progressions') ? undefined : (json['progressions'].map(_1.QuestProgressionFromJSON)),
    };
}
exports.ChallengeInfoResponseAllOfFromJSONTyped = ChallengeInfoResponseAllOfFromJSONTyped;
function ChallengeInfoResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isAccepted': value.isAccepted,
        'prizes': (value.prizes.map(_1.PrizePoolToJSON)),
        'winners': value.winners === undefined ? undefined : (value.winners.map(_1.ChallengeMembershipToJSON)),
        'brandMapSlug': value.brandMapSlug,
        'instantReward': (0, _1.ChallengeInstantRewardToJSON)(value.instantReward),
        'dismissedCompleteFeedBack': value.dismissedCompleteFeedBack,
        'games': value.games === undefined ? undefined : (value.games.map(_1.OWGameResponseToJSON)),
        'quests': value.quests === undefined ? undefined : (value.quests.map(_1.QuestConfigToJSON)),
        'progressions': value.progressions === undefined ? undefined : (value.progressions.map(_1.QuestProgressionToJSON)),
    };
}
exports.ChallengeInfoResponseAllOfToJSON = ChallengeInfoResponseAllOfToJSON;
